import cookies from 'js-cookie';

const SESSION_KEY = 'jsh_id';

export const storeSessionId = (sessionId, lifeTimeSec = 345600) => {
  const dayInMS = lifeTimeSec * 1000;
  const expiration = new Date(new Date().getTime() + dayInMS);
  return cookies.set(SESSION_KEY, sessionId, { expires: expiration });
};
export const getSessionId = () => {
  return cookies.get(SESSION_KEY);
};
